<template>
  <layout-main>
    <div class="container">
      <div>お探しのユーザーは存在しないか、削除された可能性があります。</div>
      <div>
        <router-link to="/users">
          <md-button>
            <font-awesome-icon icon="arrow-left"/>ユーザー一覧に戻る
          </md-button>
        </router-link>
      </div>
    </div>
  </layout-main>
</template>

<script>
import LayoutMain from '@/components/layout/LayoutMain'

export default {
  components: { LayoutMain },
}
</script>


<style lang="scss" scoped>
.container {
  align-items: center;
  display: flex;
  flex-direction: column;
  height: 50vh;
  justify-content: center;
  line-height: 2rem;
}
</style>
